import React from "react";

import { ReactComponent as BuildingIcon } from "../../../assets/images/empresarial/building.svg";
import { ReactComponent as TrophyIcon } from "../../../assets/images/empresarial/trophy.svg";
import { ReactComponent as PinIcon } from "../../../assets/images/empresarial/pin.svg";
import { ReactComponent as FlameIcon } from "../../../assets/images/empresarial/flame.svg";
import { ReactComponent as CautionIcon } from "../../../assets/images/empresarial/caution.svg";
import { ReactComponent as TheftIcon } from "../../../assets/images/empresarial/theft.svg";
import { ReactComponent as StrikeIcon } from "../../../assets/images/empresarial/strike.svg";
import { ReactComponent as DocumentIcon } from "../../../assets/images/empresarial/document.svg";
import { ReactComponent as GlassIcon } from "../../../assets/images/empresarial/glass.svg";
import { ReactComponent as MoneyIcon } from "../../../assets/images/empresarial/money.svg";
import { ReactComponent as NotebookIcon } from "../../../assets/images/empresarial/notebook.svg";

import { CommonFAQ } from "./BusinessCommon.constants";

export const MultiRiskAdvantageList = [
  {
    id: 1,
    icon: BuildingIcon,
    title: "Médias e grandes empresas",
    description:
      "Cuida das suas conquistas para que sua empresa continue crescendo com segurança.",
  },
  {
    id: 2,
    icon: TrophyIcon,
    title: "Vantagens",
    description:
      "Permite personalizar o seguro com coberturas e valores que se ajustam às necessidades da sua empresa.",
  },
  {
    id: 3,
    icon: PinIcon,
    title: "Assistência 24h",
    description:
      "Inclui serviços emergenciais, como chaveiro e eletricista, para resolver os imprevistos do dia a dia.",
  },
];

export const MultiRiskCoverageList = [
  {
    id: 1,
    icon: FlameIcon,
    title: "Incêndio, queda de raio e explosão",
    description:
      "Cobre danos à empresa nesses casos, desde que ocorram dentro do terreno ou prédio onde estão os bens segurados, com sinais claros do que aconteceu.",
  },
  {
    id: 2,
    icon: CautionIcon,
    title: "Danos elétricos",
    description: (
      <>
        Cobertura para danos e perdas de bens segurados, por falhas na rede
        elétrica, como curto-circuito, superaquecimento e variações anormais de
        tensão. Vale também para danos gerados pela queda de raio fora do
        terreno.
      </>
    ),
  },
  {
    id: 3,
    icon: TheftIcon,
    title: "Roubo ou furto",
    description: (
      <>
        Em caso de roubo ou furto de máquinas, equipamentos, instalações e
        matérias-primas essenciais para o funcionamento do negócio, a
        indenização será paga de acordo com o previsto na apólice.
      </>
    ),
  },
  {
    id: 4,
    icon: StrikeIcon,
    title: "Diárias de paralisação",
    description: (
      <>
        O seu negócio sofreu com a interrupção total ou parcial das atividades
        por mais de 5 dias? O pagamento das contas de água e luz estão
        garantidos, caso a paralisação seja causada por incêndio, raio ou
        explosão.
      </>
    ),
  },
  {
    id: 5,
    icon: DocumentIcon,
    title: "Despesas de recomposição de registros e documentos",
    description: (
      <>
        Garante o reembolso de despesas necessárias para reparar danos a
        registros e documentos que estejam em uso ou guardados em depósitos. A
        cobertura é válida para qualquer perda ou destruição desses itens
        gerados por causas externas como incêndio e alagamento.
      </>
    ),
  },
  {
    id: 6,
    icon: GlassIcon,
    title: "Quebra de vidros e anúncios luminosos",
    description: (
      <>
        Indenização pelos prejuízos causados aos vidros e anúncios luminosos
        (letreiros) fixamente instalados na empresa.
      </>
    ),
  },
  {
    id: 7,
    icon: MoneyIcon,
    title: "Perda ou pagamento de aluguel até 6 meses",
    description: (
      <>
        Se for preciso desocupar o imóvel onde a empresa funciona por conta de
        uma situação coberta pelo seguro, há reembolso dos aluguéis pagos ou não
        recebidos por até seis meses. A cobertura é válida em casos de explosão,
        incêndio, queda de raio, entre outros desastres naturais previstos na
        apólice, e impacto de veículos terrestres, como carro, moto e caminhão,
        que impeçam o funcionamento do negócio.
      </>
    ),
  },
  {
    id: 8,
    icon: NotebookIcon,
    title: "Equipamentos móveis e estacionários",
    description: (
      <>
        A cobertura vale para acidentes de causa externa, como batidas de
        veículos durante o transporte do equipamento, queda de raio, entre
        outras situações previstas na apólice do seguro. Indeniza, até o valor
        máximo contratado, os prejuízos aos equipamentos da empresa.
      </>
    ),
  },
];

export const MultiRiskfaqList = [
  {
    title: "O que pode ser coberto pelo seguro?",
    body: (
      <>
        Com o Seguro Empresarial Multirrisco você consegue personalizar as
        coberturas de acordo com as suas necessidades. Caso seja cliente e tenha
        dúvidas do que está coberto, consulte a sua apólice.
      </>
    ),
  },
  {
    title: "Qual é o valor do seguro?",
    body: (
      <>
        O cálculo do valor depende de alguns fatores. Nós consideramos a
        localização, ramo, coberturas contratadas além de outros aspectos. Com
        base nessas informações o gerente Caixa realiza uma cotação e gera uma
        proposta.
      </>
    ),
  },
  {
    title: "Qual é o número de telefone para acionar o seguro?",
    body: <>Assistência e Sinistros - 0800 274 1000</>,
  },
  {
    title:
      "Se um vendaval quebrar painéis ou anúncios luminosos, o seguro cobre os prejuízos?",
    body: (
      <>
        Não. Painéis e anúncios luminosos não estão cobertos pela apólice em
        caso de vendaval, devido à alta exposição desses itens.
      </>
    ),
  },
  {
    title:
      "Para acionar o seguro em caso de roubo ou furto, é preciso apresentar a nota fiscal do bem?",
    body: (
      <>
        A nota fiscal ajuda a comprovar a existência e o modelo do bem, então é
        sempre solicitada. Mas, quando há vistoria no local onde ocorreu o roubo
        ou o furto, restos ou partes do bem (salvados) podem comprovar o
        ocorrido.
      </>
    ),
  },
  ...CommonFAQ,
];

export const MultiRiskDocumentList = [
  {
    id: 1,
    label: "Condições Gerais Seguro Multirrisco Empresarial - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Multirrisco-Empresarial-2025.pdf",
  },
  {
    id: 2,
    label: "Condições Gerais Seguro Empresarial - 2023",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2023.pdf",
  },
  {
    id: 3,
    label: "Condições Gerais Seguro Empresarial - 2021",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2021.pdf",
  },
  {
    id: 4,
    label: "Manual de Assistência - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/Manuais/Manual-de-Assistencia-2025.pdf",
  },
];
